import React, { Component } from "react";
import { connect } from "react-redux";
import { ScrollView, View, StyleSheet, Dimensions } from "react-native";
import Text from "../components_v2/TextFont";
import { IconButton } from "../components_v2/Buttons";
import RTSPPlayer from "../components/RTSPPlayer";
import { FONT_FAMILIES } from "../../assets/consts/faCharCodes";

const SCREEN_HEIGHT = Dimensions.get("screen").height;
const SCREEN_WIDTH = Dimensions.get("screen").width;
const SPINNER_SIZE = 32;
const MAX_REPEAT_ON_FAILURE = 2;
const PLAYER_MARGIN = 0.95;
class CameraMultiViewScreen extends Component {
  constructor(props) {
    super(props);
    let { cameraIds, areaId, areaName } = this.props.navigation.state.params;
    this.player = undefined;
    this.state = {
      cameraIds,
      selectedCameraId: undefined, // selected camera to display in wide mode (single column/single player)
      areaId,
      areaName,
      paused: false,
      serverUrl: undefined,
      accessToken: undefined,
      videoSources: [],
      logs: undefined,
      retryOnFailure: 0,
      showLoading: true,
      playerWidth: SCREEN_WIDTH * PLAYER_MARGIN,
      playerHeight: SCREEN_WIDTH * (9 / 16) * PLAYER_MARGIN,
      columnCount: 1,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.DeviceList"),
  });
  setColumnCount(columnCount = 1) {
    switch (columnCount) {
      case 1:
        this.setState({
          columnCount,
          playerWidth: SCREEN_WIDTH * PLAYER_MARGIN,
          playerHeight: SCREEN_WIDTH * (9 / 16) * PLAYER_MARGIN,
          selectedCameraId: undefined,
        });
        break;
      case 2:
      default:
        this.setState({
          columnCount,
          playerWidth: (SCREEN_WIDTH * PLAYER_MARGIN) / 2,
          playerHeight: (SCREEN_WIDTH * (9 / 16) * PLAYER_MARGIN) / 2,
        });
        break;
    }
  }

  setSelectedCamera = (cameraId) => {
    if (cameraId && Number(cameraId)) {
      this.setState({ selectedCameraId: cameraId }, () => {
        console.log(
          "state.selectedCameraId in CameraMultiViewScreen",
          this.state.selectedCameraId
        );
      });
    }
  };

  clearSelectedCamera = () => {
    this.setState({ selectedCameraId: undefined });
  };

  render() {
    let isPortrait = SCREEN_WIDTH < SCREEN_HEIGHT;
    return (
      <ScrollView style={isPortrait ? styles.container : {}}>
        <View style={{ flexDirection: "row", marginBottom: 15 }}>
          {/* area name */}
          <View style={{ flex: 1, margin: 15 }}>
            <Text
              style={{
                color: "#CCC",
                fontWeight: "bold",
                fontSize: 32,
              }}
            >
              {this.state.areaName}
            </Text>
          </View>
          {/* end area name */}

          {/* toggle columns */}
          <View
            style={{
              backgroundColor: "#333",
              height: 38 + 2 * 3,
              padding: 3,
              margin: 15,
              width: 38 * 2 + 16,
              borderRadius: 21,
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <IconButton
              onPress={() => {
                this.setColumnCount(1);
              }}
              style={
                this.state.columnCount == 1
                  ? { ...styles.toggleButton, ...styles.toggleButtonActive }
                  : { ...styles.toggleButton, ...styles.toggleButtonDeActive }
              }
              icon={{
                code: "\uf04c", // single column
                style:
                  this.state.columnCount == 1
                    ? {
                        ...styles.toggleButtonIcon,
                        ...styles.toggleButtonIconActive,
                        transform: [{ rotate: "90deg" }],
                      }
                    : {
                        ...styles.toggleButtonIcon,
                        ...styles.toggleButtonIconDeActive,
                        transform: [{ rotate: "90deg" }],
                      },
              }}
            />
            <IconButton
              onPress={() => {
                this.setColumnCount(2);
              }}
              style={
                this.state.columnCount == 2
                  ? { ...styles.toggleButton, ...styles.toggleButtonActive }
                  : { ...styles.toggleButton, ...styles.toggleButtonDeActive }
              }
              icon={{
                code: "\uf009", //"\uf58e",  two columns
                style:
                  this.state.columnCount == 2
                    ? {
                        ...styles.toggleButtonIcon,
                        ...styles.toggleButtonIconActive,
                      }
                    : {
                        ...styles.toggleButtonIcon,
                        ...styles.toggleButtonIconDeActive,
                      },
              }}
            />
          </View>
          {/* end toggle columns */}
        </View>
        <View>
          <View
            style={{
              flex: 1,
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "space-around",
            }}
          >
            {this.state.cameraIds.map((cameraId, idx) => {
              return (
                <RTSPPlayer
                  key={cameraId}
                  cameraId={cameraId}
                  width={
                    this.state.selectedCameraId == cameraId
                      ? SCREEN_WIDTH
                      : this.state.playerWidth
                  }
                  height={
                    this.state.selectedCameraId == cameraId
                      ? SCREEN_WIDTH * (9 / 16)
                      : this.state.playerHeight
                  }
                  spinnerSize={SPINNER_SIZE}
                  maxRepeatOnFailure={MAX_REPEAT_ON_FAILURE}
                  style={{ marginBottom: 15 }}
                  onTouch={() => {
                    // put screen in single device mode if is in grid mode (columns > 2)
                    if (this.state.columnCount > 1) {
                      if (this.state.selectedCameraId != cameraId) {
                        this.setSelectedCamera(cameraId);
                      } else {
                        this.clearSelectedCamera();
                      }
                    } else {
                      this.clearSelectedCamera();
                    }
                  }}
                />
              );
            })}
          </View>
        </View>
      </ScrollView>
    );
  }
}

const styles = StyleSheet.create({
  logs: {
    color: "#ccc",
    textAlign: "center",
  },
  container: {
    flex: 1,
    backgroundColor: "#000",
    //paddingTop: 30,
    //justifyContent: "center",
    // , alignItems : 'center'
  },
  playerStyle: {
    width: SCREEN_WIDTH,
    height: SCREEN_WIDTH * (9 / 16),
    borderColor: "#f00",
    borderWidth: 1,
    // alignSelf: "center"
  },
  toggleButton: {
    width: 38,
    height: 38,
    borderRadius: 21,
    //padding: 9,
    //alignItems : "center",
    justifyContent: "center",
  },
  toggleButtonActive: {
    backgroundColor: "#fff",
  },
  toggleButtonDeActive: {
    backgroundColor: "#555",
  },
  toggleButtonIcon: {
    fontFamily: FONT_FAMILIES.PRO_REGULAR,
    fontSize: 20,
  },
  toggleButtonIconActive: {
    color: "#333",
  },
  toggleButtonIconDeActive: {
    color: "#666",
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.DeviceReducer,
  };
};

export default connect(mapStateToProps)(CameraMultiViewScreen);
